import { useContext, useState } from 'react';
import { CheckIcon, XMarkIcon } from '@heroicons/react/24/outline';
import Button from 'components/commercetools-ui/atoms/button';
import Drawer from 'components/commercetools-ui/atoms/drawer';
import Typography from 'components/commercetools-ui/atoms/typography';
import { Market } from 'components/commercetools-ui/organisms/header/types';
import FlagIcons from 'components/icons/flags';
import { MarketContext } from 'context/market';
import { useFormat } from 'helpers/hooks/useFormat';

const MarketButton = () => {
  const [showMarket, setShowMarket] = useState(false);
  const { market: selectedMarket, markets, handleMarket } = useContext(MarketContext);

  const { formatMessage } = useFormat({ name: 'common' });

  const showMarketMenu = () => {
    setShowMarket(true);
  };

  const hideMarketMenu = () => {
    setShowMarket(false);
  };

  const handleMarketClick = (market: Market) => {
    handleMarket(market);
    setShowMarket(false);
  };
  return (
    <div className="hidden w-fit justify-center lg:flex">
      {selectedMarket && (
        <Button variant="ghost" size="fit" onClick={showMarketMenu} className="flex w-fit cursor-default items-center">
          <FlagIcons flagName={selectedMarket?.flag} className="mr-3 h-16 w-24" />
          <Typography className="ml-5 text-14 font-normal text-neutral-100 hover:underline">
            {selectedMarket?.region}
          </Typography>
        </Button>
      )}
    </div>
  );
};
export default MarketButton;
